<!-- Management -->
<svg:path
    class="filter-blur"
    [attr.d]="shadowPath()"
    fill="var(--shade-bg)" />
